module.exports = __webpack_public_path__ + "assets/img/aqx.df2449bc.jpg";